// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"1528cab8","196":"02ae1047","271":"91c360ef","394":"786211b1","408":"aef81080","468":"158fce39","767":"8ca3b668"}[chunkId] + ".chunk.js";
};